import type { CSSProperties, ElementType, ReactNode } from 'react';

import {
  StyledText,
  type TextVariant,
  type TextColorPreset,
} from './Text.styled';

type TextProps = {
  variant?: TextVariant;
  color?: TextColorPreset | string;
  fontSize?: number;
  fontWeight?: number;
  as?: ElementType;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  align?: 'left' | 'center' | 'right' | 'justify';
};

export default function Text({
  variant = 'body',
  color,
  fontSize,
  fontWeight,
  children,
  ...props
}: TextProps) {
  return (
    <StyledText
      $variant={variant}
      $color={color}
      $fontSize={fontSize}
      $fontWeight={fontWeight}
      {...props}
    >
      {children}
    </StyledText>
  );
}
